import React from 'react';

import { TTab, Tab } from '@/components/global/Tabs/Tab';
import { Tabs as TabsGlobal } from '@/components/global/Tabs';

export const Tabs = ({
  tabItems,
  handleTabClick,
}: {
  tabItems: TTab[];
  handleTabClick: (tabId: string) => void;
}) => {
  return tabItems.length === 1 ? (
    <div className="vitrine-template__tabs">
      <Tab data={tabItems[0]} onClick={() => null} />
    </div>
  ) : (
    <TabsGlobal items={tabItems} onClick={handleTabClick} />
  );
};
